
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFFFFF",
        "d": "M31.982,8.908c-1.418,0.029-2.546,1.258-2.519,2.746\n\tc0.026,1.49,1.208,3.271,2.627,3.242c1.417-0.027,2.534-1.854,2.507-3.345C34.57,10.063,33.4,8.88,31.982,8.908L31.982,8.908z\n\t M16.832,8.908c-1.418,0.029-2.545,1.258-2.518,2.746c0.026,1.49,1.208,3.271,2.626,3.242c0.357-0.007,0.696-0.129,1.002-0.331\n\tc0.122-0.118,0.255-0.227,0.397-0.323c0.684-0.671,1.125-1.746,1.107-2.69C19.422,10.063,18.25,8.88,16.832,8.908L16.832,8.908z\n\t M16.881,18.047L16.881,18.047c-0.125,0.955-0.228,1.922-0.23,2.846c-0.006,1.545,0.298,3.124,0.582,4.637\n\tc0.208,1.111,1.127,1.911,2.166,2.28l0.297,9.284c0.009,0.251,0.053,0.492,0.125,0.728c-0.3,0.437-0.826,0.73-1.318,0.73\n\tc-0.49,0-1.101-0.198-1.35-0.509c-0.139-0.174-0.404-0.174-0.543,0c-0.25,0.311-0.86,0.509-1.35,0.509\n\tc-0.729,0-1.539-0.647-1.563-1.447l-0.322-10.014l-0.39-0.052c-0.706-0.094-1.549-0.559-1.68-1.256\n\tc-0.781-4.159-0.623-4.352-0.06-8.707c0.082-0.314,0.433-0.867,1.089-0.943l2.75-0.324c0.176-0.021,0.344,0.045,0.441,0.191\n\tL16.881,18.047L16.881,18.047z M32.03,18.047L33.386,16c0.099-0.146,0.265-0.212,0.441-0.191l2.751,0.324\n\tc0.656,0.076,1.007,0.629,1.088,0.943c0.563,4.355,0.722,4.548-0.06,8.707c-0.131,0.697-0.974,1.162-1.679,1.256l-0.391,0.052\n\tl-0.321,10.014c-0.026,0.8-0.835,1.447-1.563,1.447c-0.49,0-1.101-0.198-1.351-0.509c-0.138-0.174-0.404-0.174-0.542,0\n\tc-0.25,0.311-0.861,0.509-1.35,0.509c-0.492,0-1.02-0.294-1.319-0.73c0.073-0.233,0.116-0.477,0.124-0.728l0.299-9.284\n\tc1.039-0.369,1.957-1.169,2.166-2.28c0.284-1.513,0.586-3.092,0.581-4.637C32.257,19.969,32.155,19.002,32.03,18.047L32.03,18.047z\n\t M24.404,7.703c-1.474,0.029-2.647,1.31-2.619,2.858c0.027,1.55,1.256,3.403,2.732,3.374c1.476-0.029,2.638-1.929,2.609-3.479\n\tC27.1,8.906,25.881,7.672,24.404,7.703L24.404,7.703z M24.455,17.213l1.41-2.129c0.104-0.152,0.277-0.221,0.46-0.201l2.863,0.338\n\tc0.683,0.081,1.047,0.657,1.132,0.982c0.586,4.535,0.75,4.733-0.063,9.061c-0.137,0.726-1.013,1.211-1.747,1.307l-0.406,0.054\n\tL27.77,37.045c-0.026,0.832-0.868,1.507-1.627,1.507c-0.51,0-1.145-0.206-1.404-0.529c-0.145-0.18-0.422-0.18-0.564,0\n\tc-0.26,0.323-0.896,0.529-1.404,0.529c-0.76,0-1.601-0.675-1.628-1.507l-0.334-10.421L20.4,26.57\n\tc-0.733-0.096-1.61-0.581-1.747-1.307c-0.813-4.327-0.648-4.525-0.062-9.061c0.084-0.325,0.449-0.901,1.132-0.982l2.862-0.338\n\tc0.184-0.02,0.357,0.049,0.459,0.201L24.455,17.213L24.455,17.213z"
      }
    }
  ]
})
    }
  